const mimeTypes: { [key: string]: string } = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  svg: 'image/svg+xml',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  txt: 'text/plain',
  webp: 'image/webp',
  pfx: 'application/x-pkcs12',
  // Adicionar outros tipos conforme necessário
};

export const getMimeTypeFromExtension = (extension: string): string => {
  return mimeTypes[extension || ''] || 'application/octet-stream';
};

export const getExtensionFromMimeType = (mimeType: string): string => {
  const entry = Object.entries(mimeTypes).find(([key, value]) => value === mimeType);
  return entry ? entry[0] : '';
};

export const getExtensionFromFileName = (fileName: string): string => {
  if (!fileName) return '';
  const extension = fileName.split('.').pop();
  return extension ? extension.toLowerCase() : '';
};
